const Awards = () => {
    return (
        <div id="awards" className="vision-card awards-card">

            {/* HEADER */}

            <div className="awards-header">

                <span className="awards-eyebrow">
                    ACHIEVEMENT • EXCELLENCE • RECOGNITION
                </span>

                <h2>
                    AWARDS &amp; MEDALS
                </h2>

                <div className="awards-title-line"></div>

                <div className="awards-subtitle-wrap">
                    <span className="awards-subtitle-line"></span>

                    <p className="awards-subtitle">
                        Celebrating Excellence and Achievement
                    </p>

                    <span className="awards-subtitle-line"></span>
                </div>

            </div>


            {/* CONTENT */}

            <div className="awards-content">

                <p>
                    At Nav Jeevan Mission School, Anandnagar, we believe that
                    every achievement is a reflection of hard work, dedication,
                    discipline and perseverance. Our Awards &amp; Medals section
                    proudly recognises the accomplishments of our students,
                    teachers and school teams in various fields.
                </p>

                <p>
                    Our students are encouraged to participate in academic
                    competitions, Olympiads, sports, cultural events, arts,
                    science exhibitions, technology and other co-curricular
                    activities at school, district, state and national levels.
                </p>


                {/* AWARDS */}

                <div className="awards-section">

                    <div className="awards-section-heading">

                        <span className="awards-dot"></span>

                        <h3>
                            We Proudly Celebrate
                        </h3>

                    </div>


                    <div className="awards-list">

                        <div className="award-item">
                            <span className="award-icon">🏆</span>

                            <span className="award-text">
                                Academic Excellence Awards
                            </span>
                        </div>


                        <div className="award-item">
                            <span className="award-icon">🥇</span>

                            <span className="award-text">
                                Gold, Silver &amp; Bronze Medals
                            </span>
                        </div>


                        <div className="award-item">
                            <span className="award-icon">🏅</span>

                            <span className="award-text">
                                Olympiad &amp; Competitive Examination Achievements
                            </span>
                        </div>


                        <div className="award-item">
                            <span className="award-icon">🏆</span>

                            <span className="award-text">
                                Sports &amp; Athletic Achievements
                            </span>
                        </div>


                        <div className="award-item">
                            <span className="award-icon">🎨</span>

                            <span className="award-text">
                                Arts, Cultural &amp; Creative Achievements
                            </span>
                        </div>


                        <div className="award-item">
                            <span className="award-icon">🔬</span>

                            <span className="award-text">
                                Science, Technology &amp; Innovation Awards
                            </span>
                        </div>


                        <div className="award-item">
                            <span className="award-icon">🎤</span>

                            <span className="award-text">
                                Inter-School Competition Achievements
                            </span>
                        </div>


                        <div className="award-item">
                            <span className="award-icon">🌟</span>

                            <span className="award-text">
                                Special Recognition &amp; Outstanding Performance Awards
                            </span>
                        </div>


                        <div className="award-item">
                            <span className="award-icon">📜</span>

                            <span className="award-text">
                                Certificates of Merit and Appreciation
                            </span>
                        </div>

                    </div>

                </div>


                {/* OUR BELIEF */}

                <div className="awards-belief">

                    <div className="awards-section-heading">

                        <span className="awards-dot"></span>

                        <h3>
                            Our Belief
                        </h3>

                    </div>


                    <div className="awards-quote">

                        <span className="awards-quote-open">
                            “
                        </span>

                        <p>
                            Every achievement begins with the courage to try,
                            the determination to continue and the commitment
                            to excel.
                        </p>

                        <span className="awards-quote-close">
                            ”
                        </span>

                    </div>

                </div>


                {/* CLOSING */}

                <p className="awards-final-text">

                    These awards and medals inspire our students to set higher
                    goals, appreciate the value of hard work and continue their
                    journey towards excellence with humility and integrity.

                </p>


                <div className="awards-closing">

                    <strong>
                        Nav Jeevan Mission School
                    </strong>

                    <span>
                        Celebrating Talent, Inspiring Excellence.
                    </span>

                </div>

            </div>

        </div>
    );
};

export default Awards;